<template>
  <el-divider></el-divider>
  <div class="footer-nav">
    <div
      style="display:flex; width:100%; flex-shrink:0; padding-top:20px; padding-bottom:0px; justify-content:center; max-width:1250px;margin-left:80px"
    >
      <div class="footer_3">
        <span class="footer_title">服务与支持</span><br />
        <p
          class="footer_content"
          @click="
            goPage('shop');
            scrollToTop;
            backTop(scrollTop);
          "
        >
          服务门店
        </p>
        <p
          class="footer_content"
          @click="
            goPage('repair');
            scrollToTop;
            backTop(scrollTop);
          "
        >
          保修政策
        </p>
        <p
          class="footer_content"
          @click="
            goPage('problems');
            scrollToTop;
            backTop(scrollTop);
          "
        >
          常见问题
        </p>
        <p
          class="footer_content"
          @click="
            goPage('query');
            scrollToTop;
            backTop(scrollTop);
          "
        >
          备件价格查询
        </p>
      </div>

      <div class="footer_3">
        <span class="footer_title">预置应用公示</span><br />
        <p
          class="footer_content"
          @click="
            goPage('message');
            scrollToTop;
            backTop(scrollTop);
          "
        >
          预置应用公示
        </p>
      </div>

      <div class="footer_3">
        <span class="footer_title">购买产品</span><br />
        <p
          class="footer_content"
          @click="
            goPage('productDetails/3');
            scrollToTop;
            backTop(scrollTop);
          "
        >
          NZONE S7
        </p>
        <p
          class="footer_content"
          @click="
            goPage('productDetails/1');
            scrollToTop;
            backTop(scrollTop);
          "
        >
          NZONE S7 PRO 5G
        </p>
        <p
          class="footer_content"
          @click="
            goPage('productDetails/2');
            scrollToTop;
            backTop(scrollTop);
          "
        >
          NZONE S7 PRO+ 5G
        </p>
                <p
          class="footer_content"
          @click="
            goPage('productDetails/4');
            scrollToTop;
            backTop(scrollTop);
          "
        >
          NZONE 50 PRO
        </p>
      </div>

      <div class="footer_3">
        <span class="footer_title">联系我们</span><br />
        <p class="footer_content">消费者服务电话</p>
        <p class="footer_content" style="color:red">400-699-6999</p>
      </div>

      <div class="footer_4">
        <span class="footer_title">关注我们</span><br />
        <div style="display:flex; cursor:pointer; margin-top:10px">
          <img
            src="../assets/images/weibo.png"
            style="height:30px"
            @click="openWeibo"
          />
          <div class="wechat">
            <div style="display:flex;cursor:pointer;margin-left:10px">
              <img src="../assets/images/wechat.png" style="height:30px" />
              <div class="code">
                <img src="../assets/images/code.png" style="height:100px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <el-divider style="width:100%;"></el-divider>
  <div style="display:flex; justify-content:center; margin-left:40px">
    <div class="footer-nav" style="justify-content:center; max-width:1250px">
      <!-- <div>
     <span class="footer_2">公司简介</span>
     <el-divider direction="vertical"></el-divider>
     <span class="footer_2">企业文化</span>
     <el-divider direction="vertical"></el-divider>
     <span class="footer_2">联系我们</span>
     <el-divider direction="vertical"></el-divider>
     <span class="footer_2">网站地图</span>
     <el-divider direction="vertical"></el-divider>
     <span class="footer_2">营业执照</span>
     <span style=" margin-left:10px" class="footer_2">
       违法和不良信息举报电话：4001088188
     </span>
     </div> -->
      <div>
        <img src="../assets/images/police.png" />
      </div>

      <div>
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52010202003985"
          target="_blank"
          class="footer_2"
          style="text-decoration:none; color:black"
          >贵公网安备 52010202003985号</a
        >
      </div>
      <div style="margin-left:5vw">
        <!-- <span class="footer_2">黔ICP备2023005185号-10</span> -->
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          class="footer_2"
          style="text-decoration:none; color:black"
          >黔ICP备2023005185号-10</a
        >
      </div>
    </div>
  </div>

  <!-- <el-divider style="width:100%; margin-bottom:0"></el-divider> -->
</template>

<script>
import { defineComponent, onBeforeMount, onBeforeUnmount, ref } from "vue";
import router from "../router/index.ts";

let scrollToTop = () => {
  let scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  let res = ref(scrollTop);
  return res;
};

let backTop = scrollTop => {
  let timer = setInterval(() => {
    let ispeed = Math.floor(scrollTop / 5);
    document.documentElement.scrollTop = document.body.scrollTop =
      scrollTop + ispeed;
    if (scrollTop == 0) {
      clearInterval(timer);
    }
  }, 16);
};

export default defineComponent({
  methods: {
    openWeibo() {
      window.open("https://weibo.com/u/7617583524");
    }
  },

  setup() {
    let scrollTop = ref(0);
    let v = scrollToTop();
    scrollTop = v;

    onBeforeMount(() => {
      window.addEventListener("scroll", scrollToTop);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", scrollToTop);
    });

    let goPage = path => {
      router.push("/" + path);

      setTimeout(() => {
        window.location.reload();
      }, 100);
      window.scrollTo(0, 0);
    };

    return { scrollTop, scrollToTop, backTop, goPage };
  }
});
</script>

<style scoped>
.footer-nav {
  /* width:1920px; */
  width: 100%;
  display: flex;
  justify-content: center;
  white-space: nowrap;
}

.footer-nav1 {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  white-space: nowrap;
}

.footer_title {
  font-style: Roboto;
  font-size: 18px;
  font-weight: bold;
}

.footer_content {
  font-style: Roboto;
  font-size: 16px;
  cursor: pointer;
}

.footer_2 {
  font-style: SourceHanSansSC-regular;
  font-size: 12px;
}

.footer_3 {
  margin-top: 20px;
  text-align: left;
  width: 13.5vw;
  min-width: 150px;
  margin-left: 1vw;
  flex-shrink: 0;
}

.footer_4 {
  margin-top: 20px;
  text-align: left;
  width: 3vw;
  min-width: 150px;
  margin-left: 1vw;
  flex-shrink: 0;
}

.wechat .code {
  display: none;
}

.wechat:hover .code {
  display: block;
  margin-top: -40px;
  margin-left: 20px;
}
</style>
